// R-131-LLM-D — scrub common PII patterns before Vertex generateContent.

export const PII_REDACTION = {
  email: '[email-redacted]',
  phone: '[phone-redacted]',
  id: '[id-redacted]',
  card: '[card-redacted]',
} as const;

interface PiiPattern {
  re: RegExp;
  replacement: string;
}

/**
 * Ordered patterns — credit-card and ID shapes before phone so digit runs
 * don't get partially matched as phones. Site names, street addresses, MW
 * values, and company names are intentionally out of scope.
 */
const PII_PATTERNS: readonly PiiPattern[] = [
  {
    re: /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g,
    replacement: PII_REDACTION.email,
  },
  {
    re: /\b(?:\d{4}[\s-]?){3}\d{4}\b/g,
    replacement: PII_REDACTION.card,
  },
  {
    re: /\b\d{4}[\s-]?\d{6}[\s-]?\d{5}\b/g,
    replacement: PII_REDACTION.card,
  },
  {
    re: /\b\d{3}[-\s]\d{2}[-\s]\d{4}\b/g,
    replacement: PII_REDACTION.id,
  },
  {
    re: /\b\d{2}-\d{7}\b/g,
    replacement: PII_REDACTION.id,
  },
  {
    re: /(?:\+?1[\s.-]?)?(?:\(\d{3}\)|\d{3})[\s.-]?\d{3}[\s.-]?\d{4}\b/g,
    replacement: PII_REDACTION.phone,
  },
  {
    re: /\+\d{1,3}[\s.-]?(?:\d[\s.-]?){7,14}\d\b/g,
    replacement: PII_REDACTION.phone,
  },
];

export function redactPii(text: string): { text: string; redactedCount: number } {
  let redactedCount = 0;
  let out = text;
  for (const { re, replacement } of PII_PATTERNS) {
    re.lastIndex = 0;
    out = out.replace(re, () => {
      redactedCount += 1;
      return replacement;
    });
  }
  return { text: out, redactedCount };
}
